import React, { Fragment } from "react"
import { string, shape, func, node, object, bool } from "prop-types"
import classnames from "classnames"
import ModernButton from "shared/components/Button/ModernButton.js"
import ThemeConsumer from "../ThemeConsumer"
import Typograph from "components/Typograph"

const Prompt = ({
  theme,
  icons,
  centerText,
  iconName = "",
  children,
  onClickNo,
  onClickYes,
  idButtonYes,
  idButtonNo,
  hiddenButtons
}) => {
  const Icon = icons[iconName]

  const questionClasses = classnames(
    theme.question,
    centerText ? "Grid-cell--center" : "",
    "u-flexInline u-flexAlignItemsCenter"
  )

  return (
    <section className={theme.prompt}>
      <blockquote className={theme.inner}>
        <Typograph
          htmlTag="p"
          size="extra_small"
          color="blue_cola"
          weight="semi_bold"
          classNames="u-flex u-flexAlignItemsCenter"
        >
          <Typograph
            htmlTag="span"
            size="extra_small"
            color="blue_cola"
            classNames={questionClasses}
          >
            {Icon && <Icon className={theme.mr2} />}
            {children}
          </Typograph>
          {!hiddenButtons && (
            <Fragment>
              <ModernButton
                type="button"
                id={idButtonYes}
                withBorderRadius
                text="Sim"
                textColor="white"
                size="extra_small"
                shape="full"
                buttonColor="blue_cola"
                onClick={onClickYes}
                classNames={theme.mr2}
              />
              <ModernButton
                type="button"
                id={idButtonNo}
                withBorderRadius
                text="Não"
                textColor="blue_cola"
                size="extra_small"
                shape="outline"
                buttonColor="blue_cola"
                onClick={onClickNo}
              />
            </Fragment>
          )}
        </Typograph>
      </blockquote>
    </section>
  )
}

Prompt.propTypes = {
  children: node.isRequired,
  onClickNo: func,
  onClickYes: func,
  theme: shape({
    prompt: string,
    inner: string
  }),
  icons: object,
  iconName: string,
  idButtonNo: string,
  idButtonYes: string,
  hiddenButtons: bool,
  centerText: bool
}

Prompt.defaultProps = {
  onClickNo: () => {},
  onClickYes: () => {},
  theme: {},
  hiddenButtons: false
}

export default ThemeConsumer("UIPrompt")(Prompt)



// WEBPACK FOOTER //
// ./src/shared/components/Prompt/index.js